// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footerSection__lOAnH {
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  border-top: 1px solid rgba(128, 128, 128, 0.1882352941);
}

.Footer_footerTopContents__yJSr6 {
  display: flex;
  gap: 24px;
  justify-content: space-between;
  padding: 48px 0 0;
  flex-wrap: wrap;
  padding-right: 120px;
}
@media (max-width: 1100px) {
  .Footer_footerTopContents__yJSr6 {
    padding-right: 0px;
  }
}
@media (max-width: 800px) {
  .Footer_footerTopContents__yJSr6 {
    justify-content: flex-start;
  }
}
.Footer_footerTopContents__yJSr6 .Footer_footerLogo__rIfyk img {
  height: 64px;
  width: 74px;
  object-fit: contain;
}
@media (max-width: 767px) {
  .Footer_footerTopContents__yJSr6 .Footer_footerLogo__rIfyk img {
    height: 50px;
    width: 60px;
  }
}
.Footer_footerTopContents__yJSr6 h4 {
  color: #fff;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 110%;
}
.Footer_footerTopContents__yJSr6 h4 span {
  color: rgb(235, 120, 59);
}
.Footer_footerTopContents__yJSr6 ul li {
  color: rgb(24, 25, 24);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  margin-bottom: 18px;
}
.Footer_footerTopContents__yJSr6 ul li:nth-child(1) {
  color: rgb(24, 25, 24);
  font-weight: 600;
}

.Footer_bottomContents__lrdJQ {
  padding-bottom: 48px;
}
.Footer_bottomContents__lrdJQ span {
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  margin-top: 24px;
}

.Footer_footerLinks__3\\+3cY {
  display: flex;
  flex-wrap: wrap;
  gap: 100px;
}
@media (max-width: 767px) {
  .Footer_footerLinks__3\\+3cY {
    gap: 60px;
  }
}
.Footer_footerLinks__3\\+3cY a {
  text-decoration: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;UAAA,0BAAA;EACA,uDAAA;AACJ;;AAEE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AACJ;AAAI;EAPF;IAQI,kBAAA;EAGJ;AACF;AAFI;EAVF;IAWI,2BAAA;EAKJ;AACF;AAFM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAIR;AAHQ;EAJF;IAKI,YAAA;IACA,WAAA;EAMR;AACF;AAHI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAKN;AAJM;EACE,wBAAA;AAMR;AAFM;EACE,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,mBAAA;AAIR;AAHQ;EACE,sBAAA;EACA,gBAAA;AAKV;;AAAE;EACE,oBAAA;AAGJ;AAFI;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAIN;;AADE;EACE,aAAA;EACA,eAAA;EACA,UAAA;AAIJ;AAHI;EAJF;IAKI,SAAA;EAMJ;AACF;AALI;EACE,sBAAA;AAON","sourcesContent":[".footerSection {\n    backdrop-filter: blur(2px);\n    border-top: 1px solid #80808030;\n\n  }\n  .footerTopContents {\n    display: flex;\n    gap: 24px;\n    justify-content: space-between;\n    padding: 48px 0 0;\n    flex-wrap: wrap;\n    padding-right: 120px;\n    @media (max-width: 1100px) {\n      padding-right: 0px;\n    }\n    @media (max-width: 800px) {\n      justify-content: flex-start;\n    }\n    & .footerLogo{\n\n      & img{\n        height: 64px;\n        width: 74px;\n        object-fit: contain;\n        @media (max-width: 767px) {\n          height: 50px;\n          width: 60px;\n        }\n      }\n    }\n    & h4 {\n      color: #fff;\n      font-family: Roboto;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 900;\n      line-height: 110%;\n      & span {\n        color: rgb(235 120 59);\n      }\n    }\n    ul {\n      li {\n        color: rgb(24 25 24);\n        font-family: Roboto;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 140%; /* 22.4px */\n        margin-bottom: 18px;\n        &:nth-child(1){\n          color: rgb(24 25 24);\n          font-weight: 600;\n        }\n      }\n    }\n  }\n  .bottomContents {\n    padding-bottom: 48px;\n    & span{\n      display: inline-block;\n      font-size: 12px;\n      line-height: 16px;\n      margin-top: 24px;\n    }\n  }\n  .footerLinks{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 100px;\n    @media (max-width: 767px) {\n      gap: 60px;\n    }\n    & a{\n      text-decoration: unset;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerSection": `Footer_footerSection__lOAnH`,
	"footerTopContents": `Footer_footerTopContents__yJSr6`,
	"footerLogo": `Footer_footerLogo__rIfyk`,
	"bottomContents": `Footer_bottomContents__lrdJQ`,
	"footerLinks": `Footer_footerLinks__3+3cY`
};
export default ___CSS_LOADER_EXPORT___;
